module.exports = __webpack_public_path__ + "static/img/125.9273de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/125.png
// module id = PmNo
// module chunks = 0